<template>
  <div class="civii-collapse-mb">
    <div class="civii-collapse-titulo" :class="{ 'border-active': abrir }" @click="collapse">
      <span>{{titulo}}</span>
      <span class="icono-flecha-abrir" v-if="abrir"></span>
      <span v-else class="icono-flecha-cerrar"></span>
    </div>
    <div class="civii-collapse content" v-show="abrir">
      <ul :id="propiedadId">
        <li v-for="(item, index) in lista" :key="index">
          {{item[propiedadNombre]}}
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped>
.civii-collapse.content{
  background-color: #ebebeb;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
}
.civii-collapse.content ul{
  margin: 0;
  padding: .5rem 2rem;
  line-height: 1.4;
  list-style: none;
}
.civii-collapse.content ul li::before{
  content: "\2022";
  font-weight: bold;
  display: inline-block; 
  width: 1em;
  margin-left: -1.2em;
  color: #07adef;
}
.civii-collapse-mb{
  margin-bottom: .5rem;
}
.icono-flecha-abrir:after{
  content: "˅";
  margin: 0 0 0 .5rem;
}
.icono-flecha-cerrar:after{
  content: "˄";
  margin: 0 0 0 .5rem;
}
.civii-collapse-titulo{
  display: flex;
  background-color: transparent;
  border-radius: 15px;
  border: 1px solid #07adef;
  color: #07adef;
  justify-content: space-between;
  padding: 1rem;
  align-items: center;
  font-weight: 500;
}
.border-active {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.civii-collapse-titulo:hover{
  background-color: #07adef;
  color: #fff;
  cursor: pointer;
}

</style>

<script>
export default {
  props: {
    titulo: {
      type: String,
    },
    lista: {
      type: Array,
    },
    propiedadId:{
      type: String,
    },
    propiedadNombre:{
      type: String,
    }
  },
  methods: {
    collapse(){
     this.abrir = !this.abrir
    }
  },
  data: function () {
    return {
      abrir: false
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/answers/Collapse/Collapse.vue